export default {
  mock: {
    config: {},
    headers: {},
    status: 200,
    statusText: '',
    data: {}
  }
}